"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = useToken;

var _react = require("react");

var _elementStyles = require("@rexlabs/element-styles");

function useToken() {
  var _useContext = (0, _react.useContext)(_elementStyles.StylesContext),
      tokens = _useContext.tokens;

  return (0, _react.useMemo)(function () {
    return (0, _elementStyles.createTokenFn)(tokens || {});
  }, [tokens]);
}